import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bimobject': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 32c17.6 0 32 14.4 32 32v384c0 17.6-14.4 32-32 32h-384c-17.6 0-32-14.4-32-32v-384c0-17.6 14.4-32 32-32h384zM352 289.4h-0.1v-35c0-49.4-11.4-82.5-103.8-82.5h-17.3c-30 0-65.1 8.3-69.7 38.8h-1.1v-74.7h-64v232h64v-34.8h0.9c8 23.9 26.3 38.8 70.4 38.8h16.9c92.4 0 103.8-33.2 103.8-82.6zM288 260.5v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-0.2 38.4 12 38.4 33.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bimobject.js
// module id = 724
// module chunks = 0